<template>
    <div style="background-image:url(logoBg.jpg);background-size: 100% 100%;position: absolute;width: 100%;">
        <div class="TopTitle">车辆查询</div>
        <div >
            <div style="margin: 0px 26px 0px 20px;margin-top: 70%;">
                <input class="SearchInput" placeholder="请输入车牌号" v-model="carno" autofocus="autofocus"/>
            </div>
            <div @click="onSearch" class="SearchBtn">查询</div>
        </div>

        <van-popup v-model="page.show" position="bottom" style="width: 100%; height: 100%">
      <div>
        <van-nav-bar
          left-arrow
          :title="page.title"
          left-text="返回"
          @click-left="BtnLeft">
        </van-nav-bar>
        <component :is="page.name" :values="page.carvalues" :prolist="prolist" :seqconst="seqconst"></component>
      </div>
    </van-popup>
    </div>
</template>

<script>
import { NavBar, Popup, Toast } from 'vant'
import WxCarSearchDetailed from '@/views/WxCarQuery/WxCarSearchDetailed'
import { isCarNo } from '@/utils/validate'
import { weChatProgressQuery, getMiddleProcedures } from '@/utils/request'

export default {
    name: 'WxCarSearch',
    components: {
        WxCarSearchDetailed,
        [Popup.name]: Popup,
        [NavBar.name]: NavBar
    },
    data () {
        return {
            prolist: null,
            seqconst: null,
            searchText: null,
            page: {
                show: false,
                title: '',
                name: '',
                carvalues: null
            },
            carno: null,
            originalHeight: 0, // 原始高度
            screenHeight: 0, // 实时高度
            isShow: true
        }
    },
    mounted () {
            // 首次进入的原始高度
            this.originalHeight = document.documentElement.clientHeight
            window.addEventListener('resize', this.watchResize)
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.watchResize)
        },
        watch: {
            screenHeight (newHeight) { // 监听屏幕高度变化
                this.isShow = this.originalHeight <= newHeight
            }
        },
    methods: {
        onSearch () {
            if (!this.carno) {
                Toast.fail('请输入车牌号')
                return
            }
            var carNo = this.carno.toUpperCase()
            carNo = carNo.replace(/\s*/g, '')
            if (!isCarNo(carNo)) {
                Toast.fail('请输入正确的车牌号')
                return
            }

            this.page.show = true
            this.page.title = '车辆查询详细信息'
            this.page.name = 'wx-car-search-detailed'

            weChatProgressQuery(carNo).then(response => {
                this.page.carvalues = response.data

                getMiddleProcedures().then((res) => {
                    this.prolist = res.data
                    res.data.forEach(item => {
                        if (response.data.procedureId === item.id) {
                            this.seqconst = item.seq
                        }
                    })
                })
            })
        },
        BtnLeft () {
            this.page.show = false
            this.carno = null
        },
        watchResize () {
                // 实时变化的窗口高度
                this.screenHeight = document.documentElement.clientHeight
            }
    }
}
</script>
<style lang="scss" scoped>
.SearchInput {
    width: 100%;
    height: 40px;
    border-radius: 8px;
    border: 1px solid #BFBFBF;
}
.SearchBtn {
    background-color: #0256FF;
    border: 1px solid #BFBFBF;
    margin: 0px 20px;
    height: 40px;
    border-radius: 8px;
    text-align: center;
    line-height: 40px;
    color: white;
    margin-top: 10px;
}
.TopTitle{
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
}
</style>
